import { defineStore } from 'pinia';
import { useStore } from 'vuex';

export const useDaysBridgeStore = defineStore('daysBridge', () => {
	const vuex = useStore();

	const loadFirstPastDay = async (): Promise<void> => {
		await vuex.dispatch('days/loadFirstPastDay');
	};

	return {
		loadFirstPastDay,
	};
});
